import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import {PickList} from 'primereact/picklist';

const EditSelectionView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-7">
                        <TitlePage title="Control de Límite \ Selección de Garantías \ Editar "/>
                    </div>
                    <div className="p-col-5" align="right">
                        <Button label="Regresar" className="p-button-secondary"
                                onClick={props.returnGuaranteeSelection}/>&nbsp;
                        <Button label="Guardar"
                                onClick={props.saveGuaranteesSelection}/>
                    </div>
                    <div className="p-col-12"><Divider/></div>
                    <div className="p-col-1"/>
                    <div className="p-col-10">
                        <PickList source={props.sourceGuarantees}
                                  target={props.targetGuarantees}
                                  itemTemplate={props.guaranteesTemplate}
                                  sourceHeader="Tipos de Valor Disponibles"
                                  targetHeader="Tipos de Valor Seleccionados" responsive={true}
                                  sourceStyle={{height: '500px'}} targetStyle={{height: '500px'}}
                                  onChange={props.onChangePickList}
                                  showSourceControls={false} showTargetControls={false}/>
                    </div>
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(EditSelectionView);